<template>
  <div>
    <Header title="教师缓考审核" type="0" route="/homeIndex" :casLogin="casLogin"></Header>
    <div class="center">
      <div class="center-list" v-for="(item,index) in list" :key="index">
        <div class="list-left">
          <div class="left-title">{{item.kcmc}}({{item.kch}})</div>
          <div class="left-line">
            <span>学期:</span>
            <span style="margin-left: 5px;">{{item.xnxq}}</span>
          </div>
          <div class="left-line">
            <span>申请人:</span>
            <span style="margin-left: 5px;">{{item.sqr}}</span>
          </div>
          <div class="left-line">
            <span>学号:</span>
            <span style="margin-left: 5px;">{{item.xh}}</span>
          </div>
          <div class="left-line">
            <span>教师审核状态:</span>
            <span style="margin-left: 5px;">{{item.jsshztmc}}</span>
          </div>
          <div class="left-line">
            <span>最终审核状态:</span>
            <span style="margin-left: 5px;">{{item.zzshztmc}}</span>
          </div>
        </div>
        <div class="list-right">
          <van-button type="default" class="right-button" v-if="item.jsiswfmes == '2'" @click="pushDetail(item)">审核</van-button>
          <van-button type="default" class="right-button" v-else @click="pushDetail(item)">查看</van-button>
        </div>
      </div>

      <van-empty
        v-if="list.length == 0"
        class="custom-image"
        image="static/img/no_data.png"
        description="暂无数据"
      />
    </div>
  </div>
</template>
<script>
import { Empty } from 'vant';
import { Api } from '@/utils/axios'
export default {
  data() {
    return {
      casLogin: sessionStorage.getItem("casLogin"),
      list: [],
      schoolCode:''
    }
  },
  mounted() {
  },
  created(){
    this.schoolCode=sessionStorage.getItem("schoolCode");
    this.getList()
  },
  methods: {
    async getList() {
      const res = await Api.getJshkshList()
      this.list = res.data
    },
    pushDetail(item) {
      item.route=this.$route.query.path
      this.$router.push({ 
        name: 'js_jshkshDetail',
        params:{route_params: encodeURI(JSON.stringify(item))}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 20px;
}
.center-list {
  width: calc(~'100% - 80px');
  background: @attendance-background-color-10;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 20px 20px 18px 20px;
}
.list-left {
  width: calc(~'100% - 70px');
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.left-title {
  width: 100%;
  font-size: 16px;
  color: @attendance-color-1;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 8px;
}
.left-line {
  width: 100%;
  font-size: 12px;
  color: @attendance-color-2;
  margin-bottom: 2px;
}
.list-right {
  width: 70px;
  height: 100%;
  display: flex;
  align-items: center;
}
.right-button {
  width: 70px;
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  text-align: center;
  background-color: @attendance-background-color-1;
  border-radius: 3px;
}
.custom-image /deep/.van-empty__image {
  width: 130px;
  height: 130px;
}
</style>





// WEBPACK FOOTER //
// src/components/teacher/Examine/jshksh/jshkshList.vue